import SEO from "../components/site/SEO";
import {
  CTASection,
  HighlightList,
  InfoCard,
  PageHero,
  SectionHeader,
} from "../components/site/Sections";
import {
  imageLibrary,
  localSeoCoverage,
  localSeoPoints,
} from "../content/siteContent";

const LocalSeoPage = () => (
  <>
    <SEO
      title="Manutenção Elétrica Industrial em São Paulo | W-Electric Engenharia Elétrica"
      description="Serviços de manutenção elétrica industrial em São Paulo com foco em manutenção de cabine primária, ensaios elétricos, manutenção de subestações e comissionamento de painéis."
      canonicalPath="/manutencao-eletrica-industrial-sp"
      keywords={[
        "manutenção elétrica industrial em São Paulo",
        "manutenção de subestações",
        "comissionamento de painéis",
        "ensaios elétricos",
      ]}
    />

    <PageHero
      eyebrow="Atendimento local SEO"
      title="Manutenção Elétrica Industrial em São Paulo"
      description="Atuação dedicada a operações industriais, condomínios e empresas de São Paulo que precisam manter subestações, painéis elétricos e cabines primárias em alto padrão de segurança e disponibilidade."
      image={imageLibrary.technician}
      ctaMessage="Olá, preciso de manutenção elétrica industrial em São Paulo."
      testId="local-seo-hero"
    />

    <section className="container-shell py-14 md:py-20" data-testid="local-seo-overview-section">
      <div className="grid gap-6 lg:grid-cols-2">
        <InfoCard
          title="Serviços prestados em São Paulo"
          description="A W-Electric atende demandas programadas e necessidades críticas com visão de engenharia, inspeção de campo e foco em continuidade operacional."
          items={localSeoPoints}
          testId="local-seo-services-card"
        />
        <InfoCard
          title="Perfis de atendimento"
          description="Nossa atuação é adequada para clientes que precisam de rastreabilidade técnica, segurança operacional e comunicação clara com a gestão."
          items={localSeoCoverage}
          testId="local-seo-coverage-card"
          dark
        />
      </div>
    </section>

    <section className="bg-brand py-14 md:py-20" data-testid="local-seo-content-section">
      <div className="container-shell grid gap-10 lg:grid-cols-[0.95fr_1.05fr] lg:items-center">
        <SectionHeader
          eyebrow="Presença em São Paulo"
          title="Suporte técnico para infraestrutura elétrica que não pode parar"
          description="Realizamos manutenção de cabine primária, ensaios elétricos, manutenção de subestações e comissionamento de painéis com abordagem prática, documentação robusta e foco em confiabilidade."
          testId="local-seo-header"
          light
        />
        <HighlightList items={localSeoCoverage} testId="local-seo-highlight-list" light />
      </div>
    </section>

    <CTASection
      title="Sua operação precisa de suporte elétrico em São Paulo?"
      description="Solicite um contato técnico e entenda como podemos estruturar manutenção, inspeções e comissionamento com segurança e velocidade."
      buttonLabel="Solicitar contato"
      buttonMessage="Olá, preciso de suporte para manutenção elétrica industrial em São Paulo."
      testId="local-seo-cta"
    />
  </>
);

export default LocalSeoPage;